const INTERSECTION_THRESHOLD = 0.01

export default function VdLazyLoadDirective($window) {
  'ngInject'
  return {
    restrict: 'A',
    link(scope, $element, attrs) {
      const options = scope.$eval(attrs.vdLazyLoad) || {}

      if (!options.src && !options.backgroundImage) {
        return
      }

      // If the IntersectionObserver API is not supported then set the image source immediately.
      if (!$window.IntersectionObserver) {
        setImageSource()
        return
      }

      const domElement = $element[0]
      const observer = new $window.IntersectionObserver(listenForChanges, {
        threshold: INTERSECTION_THRESHOLD,
      })

      observer.observe(domElement)

      /**
       * Responds to changes generated by the IntersectionObserver
       *
       * @function listenForChanges
       *
       * @param {Array<IntersectionObserverEntry>} entries
       */
      function listenForChanges(entries) {
        entries.forEach(entry => {
          // isIntersecting is reliable when determing the visibility of the element but it not currently supported
          // in Edge, so we fall back to using intersectionRatio. @note in some instances intersectionRatio will be 0
          // even when isIntersecting is true. To avoid this and to ensure image sources are set, we use a
          // INTERSECTION_THRESHOLD that is greater than 0.
          const isIntersecting =
            typeof entry.isIntersecting === 'boolean' && entry.isIntersecting
          const hasPositiveIntersectionRatio =
            entry.intersectionRatio > INTERSECTION_THRESHOLD

          if (isIntersecting || hasPositiveIntersectionRatio) {
            observer.disconnect()
            setImageSource()
          }
        })
      }

      /**
       * Sets the defined source for the element.
       *
       * @function setImageSource
       */
      function setImageSource() {
        if (options.src) {
          attrs.$set('src', options.src)
        } else if (options.backgroundImage) {
          attrs.$set(
            'style',
            `background-image: url(${options.backgroundImage})`
          )
        }
      }

      scope.$on('$destroy', () => observer.disconnect())
    },
  }
}
